import { Injectable } from "@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { Transaction } from "@models/transaction";
import { TransactionService, TransferTransactionParams, FetchDirectDebitSummaryParams, FetchDdsTransactionsParams } from "@services/transaction";
import { ContactService } from "@services/contact";
import {
  FETCH_TRANSACTIONS,
  POPULATE_TRANSCATIONS,
  FETCH_TRANSACTIONS_FAILURE,
  FETCH_DEBTOR,
  FETCH_DEBTOR_FAILURE,
  POPULATE_ACTIVE_DEBTOR,
  CREATE_TRANSACTION,
  CREATED_TRANSACTION,
  CREATE_TRANSACTION_FAILURE,
  FETCH_POTENTIAL_TRANSACTIONS,
  POPULATE_POTENTIAL_TRANSACTIONS,
  FETCH_POTENTIAL_TRANSACTIONS_FAILURE,
  CREATE_TRANSACTION_TRANSFER_FAILURE,
  CREATED_TRANSACTION_TRANSFER,
  CREATE_TRANSACTION_TRANSFER,
  RECHARGE_TRANSACTION,
  RECHARGED_TRANSACTION,
  RECHARGE_TRANSACTION_FAILURE,
  RECORD_OTHER_PAYMENT,
  RECORDED_OTHER_PAYMENT,
  RECORD_OTHER_PAYMENT_FAILURE,
  FETCH_DIRECT_DEBIT_SUMMARIES,
  POPULATE_DIRECT_DEBIT_SUMMARIES,
  FETCH_DIRECT_DEBIT_SUMMARIES_FAILURE,
  POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY,
  FETCH_DIRECT_DEBIT_SUMMARY_FAILURE,
  FETCH_DIRECT_DEBIT_SUMMARY,
  FETCH_DDS_TRANSACTIONS,
  FETCH_DDS_TRANSACTIONS_FAILURE,
  RECHARGE_TRANSACTIONS
} from "../transactions";
import { Contact } from "@models/contact";
import { DirectDebitSummary } from "@models/direct-debit-summary";

@Injectable()

export class TransactionEffects {

  constructor(
    private actions: Actions,
    private transactionService: TransactionService,
    private contactService: ContactService,
  ) {}

  @Effect() index = this.actions
    .ofType(FETCH_TRANSACTIONS, FETCH_POTENTIAL_TRANSACTIONS)
    .switchMap((action: Action) => this.transactionService.index(action.payload)
      .map((payload: Transaction[]) => {
        switch (action.type) {
          case FETCH_TRANSACTIONS:
            return { type: POPULATE_TRANSCATIONS, payload }
          case FETCH_POTENTIAL_TRANSACTIONS:
            return { type: POPULATE_POTENTIAL_TRANSACTIONS, payload }
        }
      })
      .catch((response: any) => Observable.of({ type: FETCH_TRANSACTIONS_FAILURE }))
    )
    .share()

  @Effect() fetchDebtor = this.actions
    .ofType(FETCH_DEBTOR)
    .map((action: Action) => action.payload)
    .switchMap((id: number) => this.contactService.fetch(id)
      .map((payload: Contact) => ({ type: POPULATE_ACTIVE_DEBTOR, payload }))
      .catch((response: any) => Observable.of({ type: FETCH_DEBTOR_FAILURE }))
    )
    .share()

  @Effect() create = this.actions
    .ofType(CREATE_TRANSACTION)
    .map((action: Action) => action.payload)
    .switchMap((payload: Transaction) => this.transactionService.create(payload)
      .map(() => ({ type: CREATED_TRANSACTION }))
      .catch((response: any) => Observable.of({ type: CREATE_TRANSACTION_FAILURE }))
    )
    .share()

  @Effect() transfer = this.actions
    .ofType(CREATE_TRANSACTION_TRANSFER)
    .map((action: Action) => action.payload)
    .switchMap((payload: TransferTransactionParams) => this.transactionService.transfer(payload)
      .map(() => ({ type: CREATED_TRANSACTION_TRANSFER }))
      .catch((response: any) => Observable.of({ type: CREATE_TRANSACTION_TRANSFER_FAILURE }))
    )
    .share()

  @Effect() recharge = this.actions
    .ofType(RECHARGE_TRANSACTION)
    .map((action: Action) => action.payload)
    .switchMap((payload: number) => this.transactionService.recharge(payload)
      .map(() => ({ type: RECHARGED_TRANSACTION }))
      .catch((response: any) => Observable.of({ type: RECHARGE_TRANSACTION_FAILURE }))
    )
    .share()

  @Effect() batchRecharge = this.actions
    .ofType(RECHARGE_TRANSACTIONS)
    .map((action: Action) => action.payload)
    .switchMap((payload: number[]) => this.transactionService.batchRecharge(payload)
      .map(() => ({ type: RECHARGED_TRANSACTION }))
      .catch((response: any) => Observable.of({ type: RECHARGE_TRANSACTION_FAILURE }))
    )
    .share()

  @Effect() recordOtherPayment = this.actions
    .ofType(RECORD_OTHER_PAYMENT)
    .map((action: Action) => action.payload)
    .switchMap((payload: Transaction) => this.transactionService.recordOtherPayment(payload)
      .map(() => ({ type: RECORDED_OTHER_PAYMENT }))
      .catch((response: any) => Observable.of({ type: RECORD_OTHER_PAYMENT_FAILURE }))
    )
    .share()

  @Effect() fetchDirectDebitSummary = this.actions
    .ofType(FETCH_DIRECT_DEBIT_SUMMARY)
    .map((action: Action) => action.payload)
    .switchMap((payload: FetchDirectDebitSummaryParams) => this.transactionService.directDebitSummaryFetch(payload)
      .map((payload: DirectDebitSummary) => ({ type: POPULATE_ACTIVE_DIRECT_DEBIT_SUMMARY, payload }))
      .catch((response: any) => Observable.of({ type: FETCH_DIRECT_DEBIT_SUMMARY_FAILURE }))
    )
    .share()

  @Effect() fetchDirectDebitSummaries = this.actions
    .ofType(FETCH_DIRECT_DEBIT_SUMMARIES)
    .switchMap(() => this.transactionService.directDebitSummariesIndex()
      .map((payload: DirectDebitSummary[]) => ({ type: POPULATE_DIRECT_DEBIT_SUMMARIES, payload }))
      .catch((response: any) => Observable.of({ type: FETCH_DIRECT_DEBIT_SUMMARIES_FAILURE }))
    )
    .share()

  @Effect() fetchDdsTransactions = this.actions
    .ofType(FETCH_DDS_TRANSACTIONS)
    .map((action: Action) => action.payload)
    .switchMap((params: FetchDdsTransactionsParams) => this.transactionService.fetchDdsTransactions(params)
      .map((payload: Transaction[]) => ({ type: POPULATE_TRANSCATIONS, payload }))
      .catch((response: any) => Observable.of({ type: FETCH_DDS_TRANSACTIONS_FAILURE }))
    )
    .share()

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/transaction.ts